import { render, staticRenderFns } from "./wisdomMain.vue?vue&type=template&id=3d379972&scoped=true"
import script from "./wisdomMain.vue?vue&type=script&lang=js"
export * from "./wisdomMain.vue?vue&type=script&lang=js"
import style0 from "./wisdomMain.vue?vue&type=style&index=0&id=3d379972&prod&lang=scss&scoped=true"
import style1 from "./wisdomMain.vue?vue&type=style&index=1&id=3d379972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d379972",
  null
  
)

export default component.exports